import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	definitions: {
		marginBottom: 20
	},
}));